import { render, staticRenderFns } from "./TaskProcedureStartPopup.vue?vue&type=template&id=563a5aff"
import script from "./TaskProcedureStartPopup.vue?vue&type=script&lang=ts"
export * from "./TaskProcedureStartPopup.vue?vue&type=script&lang=ts"
import style0 from "./TaskProcedureStartPopup.vue?vue&type=style&index=0&id=563a5aff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports